// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Accordion/Disabled.story.tsx with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Accordion, AccordionItem, Button, view, css} from '@sail/ui';
import {PanelExample} from './PanelExample';

export const Disabled = () => {
  return (
    <view.div
      css={{
        background: 'surface',
        minWidth: css.value('500px'),
      }}
    >
      <Accordion>
        <AccordionItem
          title="Oranges"
          actions={
            <Button disabled onPress={() => null}>
              Edit
            </Button>
          }
        >
          <PanelExample />
        </AccordionItem>
      </Accordion>
    </view.div>
  );
};
